var HB = HB || {};

/**
 * Utility functions
 */
HB.utils = function () {
  // Cookie functions
  // modified from https://www.quirksmode.org/js/cookies.html
  function createCookie(name,value,days,pagePath) {
    var cookiePath = pagePath || '/';
    var expires = "";

    if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      expires = "; expires="+date.toGMTString();
    } else {
      expires = "";
    }

    document.cookie = name+"="+value+expires+"; path="+cookiePath;
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) { 
        return c.substring(nameEQ.length,c.length);
      }
    }
    return null;
  }

  function eraseCookie(name) {
    createCookie(name,"",-1);
  }
  
  function removeEmptyScriptIds() {
    var scripts = document.querySelectorAll('script');
    for (var i=0; i < scripts.length; i++) {
      var hasEmptyScriptIds = (scripts[i].id === '') ? true : false;
      if (hasEmptyScriptIds) {
        scripts[i].removeAttribute('id');
      }
    } 
  }

  // make methods public
  return {
    createCookie: createCookie,
    readCookie: readCookie,
    eraseCookie: eraseCookie,
    removeEmptyScriptIds: removeEmptyScriptIds
  };
}();